import { render, staticRenderFns } from "./BuscadoPaciente.vue?vue&type=template&id=6f2ce5ed"
import script from "./BuscadoPaciente.vue?vue&type=script&lang=js"
export * from "./BuscadoPaciente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports